// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/overmind-1551265297745.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/overmind-1551265297745.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/overmind-1551265297745.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/overmind-1551265297745.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#overmind" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";

@font-face {
  font-family: 'overmind';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
  font-weight: normal;
  font-style: normal;
}

[data-icon]:before {
  font-family: 'overmind' !important;
  content: attr(data-icon);
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

[class^='ovm-icon-']:before,
[class*=' ovm-icon-']:before {
  font-family: 'overmind' !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-variant: normal !important;
  text-transform: none !important;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-category-add:before {
  content: '\\66';
}
.app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-category-edit:before {
  content: '\\67';
}
.app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-category-remove:before {
  content: '\\68';
}
.app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-category-settings:before {
  content: '\\69';
}
.app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-category:before {
  content: '\\6a';
}
.app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-filepath:before {
  content: '\\6b';
}
.app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-network-sans:before {
  content: '\\6c';
}
.app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-noun-reset-415758-2:before {
  content: '\\63';
}
.app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-noun-task-1784216:before {
  content: '\\6d';
}
.app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-calendar:before {
  content: '\\61';
}
.app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-calendar-check-o:before {
  content: '\\62';
}
`, "",{"version":3,"sources":["webpack://./app/styles/fonts/overmind-icons/overmind-icons.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,uBAAuB;EACvB,4CAA8C;EAC9C;;;yDAGkE;EAClE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;EAClC,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,cAAc;EACd,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB","sourcesContent":["@charset \"UTF-8\";\n\n@font-face {\n  font-family: 'overmind';\n  src: url('./fonts/overmind-1551265297745.eot');\n  src: url('./fonts/overmind-1551265297745.eot?#iefix') format('embedded-opentype'),\n    url('./fonts/overmind-1551265297745.woff') format('woff'),\n    url('./fonts/overmind-1551265297745.ttf') format('truetype'),\n    url('./fonts/overmind-1551265297745.svg#overmind') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n[data-icon]:before {\n  font-family: 'overmind' !important;\n  content: attr(data-icon);\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n[class^='ovm-icon-']:before,\n[class*=' ovm-icon-']:before {\n  font-family: 'overmind' !important;\n  font-style: normal !important;\n  font-weight: normal !important;\n  font-variant: normal !important;\n  text-transform: none !important;\n  line-height: 1;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.ovm-icon-category-add:before {\n  content: '\\66';\n}\n.ovm-icon-category-edit:before {\n  content: '\\67';\n}\n.ovm-icon-category-remove:before {\n  content: '\\68';\n}\n.ovm-icon-category-settings:before {\n  content: '\\69';\n}\n.ovm-icon-category:before {\n  content: '\\6a';\n}\n.ovm-icon-filepath:before {\n  content: '\\6b';\n}\n.ovm-icon-network-sans:before {\n  content: '\\6c';\n}\n.ovm-icon-noun-reset-415758-2:before {\n  content: '\\63';\n}\n.ovm-icon-noun-task-1784216:before {\n  content: '\\6d';\n}\n.ovm-icon-calendar:before {\n  content: '\\61';\n}\n.ovm-icon-calendar-check-o:before {\n  content: '\\62';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ovm-icon-category-add": `app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-category-add`,
	"ovm-icon-category-edit": `app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-category-edit`,
	"ovm-icon-category-remove": `app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-category-remove`,
	"ovm-icon-category-settings": `app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-category-settings`,
	"ovm-icon-category": `app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-category`,
	"ovm-icon-filepath": `app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-filepath`,
	"ovm-icon-network-sans": `app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-network-sans`,
	"ovm-icon-noun-reset-415758-2": `app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-noun-reset-415758-2`,
	"ovm-icon-noun-task-1784216": `app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-noun-task-1784216`,
	"ovm-icon-calendar": `app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-calendar`,
	"ovm-icon-calendar-check-o": `app-styles-fonts-overmind-icons-___overmind-icons-module__ovm-icon-calendar-check-o`
};
export default ___CSS_LOADER_EXPORT___;
